import styled, { css } from 'styled-components';
import { BaseSection } from '../styles';
import { BaseDivHomePage } from '@/main/components/layouts/homepageLayout/styles';

interface ITextImageProps {
  $positionImage: 'left' | 'right';
}

export const Container = styled(BaseDivHomePage)<ITextImageProps>`
  display: grid;
  grid-template-areas: ${({ $positionImage }) =>
    $positionImage === 'left' ? css`'image text'` : css`'text image'`};
  grid-template-columns: ${({ $positionImage }) =>
    $positionImage === 'left' ? css`1fr 1fr` : css`1fr 1fr`};
  padding: 1rem;
  min-height: 50vh;
  align-items: center;
  padding: 1rem 2rem;
  gap: 2rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    display: flex;
    flex-direction: column-reverse;
  }
`;

export const AreaImage = styled.div<ITextImageProps>`
  grid-area: image;
  display: flex;
  justify-content: ${({ $positionImage }) =>
    $positionImage === 'left' ? 'flex-start' : 'flex-end'};
  align-items: center;
  position: relative;
  overflow: hidden;
`;

export const AreaText = styled.div`
  grid-area: text;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    align-items: flex-start;
  }
`;
export const Text = styled.div``;

export const Title = styled.div`
  font-size: 2.5rem;
  line-height: 1.4em;
  font-weight: bold;
  margin: 0 0 0.4rem;
  text-align: start;
  > button {
    margin-top: 20px;
    font-size: 2rem;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    text-align: center;
    width: 100%;
  }
`;

export const Description = styled.div`
  font-size: 1rem;
`;

export const Icon = styled.div`
  svg {
    width: 46px;
  }
  margin: 0 0 0.4rem;
`;

export const SubTitleSection = styled.div`
  color: #3f5ec9;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    text-align: center;
    width: 100%;
  }
`;

export type IClipBorderImage = 'right' | 'bottom' | 'left';

const ClipPathRight = css`
  clip-path: polygon(
    97.882% 99.873%,
    2.118% 99.873%,
    2.118% 99.873%,
    1.775% 99.829%,
    1.449% 99.7%,
    1.145% 99.494%,
    0.867% 99.217%,
    0.62% 98.878%,
    0.409% 98.481%,
    0.236% 98.036%,
    0.108% 97.548%,
    0.028% 97.025%,
    0% 96.473%,
    0% 3.527%,
    0% 3.527%,
    0.028% 2.975%,
    0.108% 2.452%,
    0.236% 1.964%,
    0.409% 1.519%,
    0.62% 1.122%,
    0.867% 0.783%,
    1.145% 0.506%,
    1.449% 0.3%,
    1.775% 0.171%,
    2.118% 0.127%,
    88.558% 0.127%,
    88.558% 0.127%,
    88.902% 0.171%,
    89.228% 0.3%,
    89.532% 0.506%,
    89.809% 0.783%,
    90.056% 1.122%,
    90.268% 1.519%,
    90.44% 1.964%,
    90.568% 2.452%,
    90.649% 2.975%,
    90.676% 3.527%,
    90.676% 38.459%,
    90.676% 38.459%,
    90.691% 38.854%,
    90.733% 39.238%,
    90.801% 39.609%,
    90.895% 39.963%,
    91.012% 40.296%,
    91.152% 40.606%,
    91.313% 40.89%,
    91.495% 41.144%,
    91.695% 41.366%,
    91.913% 41.551%,
    98.764% 46.586%,
    98.764% 46.586%,
    98.981% 46.771%,
    99.181% 46.992%,
    99.363% 47.246%,
    99.524% 47.53%,
    99.664% 47.84%,
    99.782% 48.174%,
    99.875% 48.528%,
    99.944% 48.898%,
    99.986% 49.282%,
    100% 49.677%,
    100% 96.473%,
    100% 96.473%,
    99.972% 97.025%,
    99.892% 97.548%,
    99.764% 98.036%,
    99.591% 98.481%,
    99.38% 98.878%,
    99.133% 99.217%,
    98.855% 99.494%,
    98.551% 99.7%,
    98.225% 99.829%,
    97.882% 99.873%
  );
`;

const ClipPathBottom = css`
  clip-path: polygon(
    0% 97.806%,
    0% 2.194%,
    0% 2.194%,
    0.033% 1.851%,
    0.129% 1.525%,
    0.283% 1.222%,
    0.489% 0.945%,
    0.742% 0.698%,
    1.037% 0.487%,
    1.37% 0.315%,
    1.733% 0.187%,
    2.123% 0.106%,
    2.534% 0.079%,
    97.466% 0.079%,
    97.466% 0.079%,
    97.877% 0.106%,
    98.267% 0.187%,
    98.631% 0.315%,
    98.963% 0.487%,
    99.258% 0.698%,
    99.511% 0.945%,
    99.717% 1.222%,
    99.871% 1.525%,
    99.967% 1.851%,
    100% 2.194%,
    100% 88.497%,
    100% 88.497%,
    99.967% 88.84%,
    99.871% 89.166%,
    99.717% 89.469%,
    99.511% 89.746%,
    99.258% 89.993%,
    98.963% 90.204%,
    98.631% 90.376%,
    98.267% 90.504%,
    97.877% 90.585%,
    97.466% 90.612%,
    71.431% 90.612%,
    71.431% 90.612%,
    71.137% 90.627%,
    70.851% 90.668%,
    70.574% 90.737%,
    70.311% 90.83%,
    70.062% 90.947%,
    69.831% 91.087%,
    69.62% 91.248%,
    69.43% 91.43%,
    69.265% 91.629%,
    69.127% 91.847%,
    65.375% 98.687%,
    65.375% 98.687%,
    65.237% 98.904%,
    65.072% 99.104%,
    64.882% 99.285%,
    64.671% 99.446%,
    64.44% 99.586%,
    64.191% 99.703%,
    63.928% 99.797%,
    63.651% 99.865%,
    63.365% 99.907%,
    63.071% 99.921%,
    2.534% 99.921%,
    2.534% 99.921%,
    2.123% 99.894%,
    1.733% 99.813%,
    1.369% 99.685%,
    1.037% 99.513%,
    0.742% 99.302%,
    0.489% 99.055%,
    0.283% 98.778%,
    0.129% 98.475%,
    0.033% 98.149%,
    0% 97.806%
  );
`;

const ClipPathLeft = css`
  clip-path: polygon(
    2.118% 99.873%,
    97.882% 99.873%,
    97.882% 99.873%,
    98.225% 99.829%,
    98.551% 99.7%,
    98.855% 99.494%,
    99.133% 99.217%,
    99.38% 98.878%,
    99.591% 98.481%,
    99.764% 98.036%,
    99.892% 97.548%,
    99.972% 97.025%,
    100% 96.473%,
    100% 3.527%,
    100% 3.527%,
    99.972% 2.975%,
    99.892% 2.452%,
    99.764% 1.964%,
    99.591% 1.519%,
    99.38% 1.122%,
    99.133% 0.783%,
    98.855% 0.506%,
    98.551% 0.3%,
    98.225% 0.171%,
    97.882% 0.127%,
    11.442% 0.127%,
    11.442% 0.127%,
    11.098% 0.171%,
    10.772% 0.3%,
    10.468% 0.506%,
    10.191% 0.783%,
    9.944% 1.122%,
    9.732% 1.519%,
    9.56% 1.964%,
    9.432% 2.452%,
    9.351% 2.975%,
    9.324% 3.527%,
    9.324% 38.459%,
    9.324% 38.459%,
    9.309% 38.854%,
    9.267% 39.238%,
    9.199% 39.609%,
    9.105% 39.963%,
    8.988% 40.296%,
    8.848% 40.606%,
    8.686% 40.89%,
    8.505% 41.144%,
    8.305% 41.366%,
    8.087% 41.551%,
    1.236% 46.586%,
    1.236% 46.586%,
    1.019% 46.771%,
    0.819% 46.992%,
    0.637% 47.246%,
    0.476% 47.53%,
    0.336% 47.84%,
    0.218% 48.174%,
    0.125% 48.528%,
    0.056% 48.898%,
    0.014% 49.282%,
    0% 49.677%,
    0% 96.473%,
    0% 96.473%,
    0.028% 97.025%,
    0.108% 97.548%,
    0.236% 98.036%,
    0.409% 98.481%,
    0.62% 98.878%,
    0.867% 99.217%,
    1.145% 99.494%,
    1.449% 99.7%,
    1.775% 99.829%,
    2.118% 99.873%
  );
`;
interface IImageProps {
  $clipBorderImage?: IClipBorderImage;
  $width?: string;
  $height?: string;
}

export const Image = styled.img<IImageProps>`
  width: 100%;
  border-radius: 8px;
  max-width: ${({ $width }) => $width || '400px'};
  height: ${({ $height }) => $height || 'auto'};
  filter: brightness(0.5);

  ${({ $clipBorderImage }) => $clipBorderImage === 'right' && ClipPathRight}
  ${({ $clipBorderImage }) =>
    $clipBorderImage === 'bottom' && ClipPathBottom}
  ${({
    $clipBorderImage
  }) =>
    $clipBorderImage === 'left' && ClipPathLeft}

  @media (
    max-width: ${({
    theme
  }) => theme.breakpoints.mobile}
  ) {
    max-width: 100%;
    height: auto;
  }
`;

export const ImageLine = styled.img`
  position: absolute;
  margin: 1rem 0;
  width: 530px;
  top: 61px;
  left: 304px;
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    top: 0px;
    left: 160px;
    max-width: 100%;
    height: auto;
  }
`;

